/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Realm from 'realm-web';

function UpdaterAccountConfirm() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  useEffect(() => {
    if (!params.get('token') || !params.get('tokenId')) {
      navigate('/505');
    } else {
      const app = new Realm.App(process.env.REACT_APP_UPDATER_APP_ID);
      app.emailPasswordAuth
        .confirmUser({
          token: params.get('token'),
          tokenId: params.get('tokenId'),
        })
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          navigate('/500');
        });
    }
  }, [params]);

  if (loading) {
    return <h2>{t('containers.UpdaterChangePassword.wait')}</h2>;
  }
  return <h1>ALL OK</h1>;
}

export default UpdaterAccountConfirm;
